import React, { useEffect, useState, useCallback } from "react";
import { LiveChatLoaderProvider, Intercom } from "react-live-chat-loader";

import { classNames } from "utils";
import useReferralCookie from "hooks/useReferralCookie";

import Header from "components/Header";
import Footer from "components/Footer";

import * as styles from "./Layout.module.less";

const isTopVerticalScroll = () =>
  (window.pageYOffset || document.documentElement.scrollTop) === 0;

/**
 *
 * @param {React.PropsWithChildren<{ gradientBackground?: boolean, whiteBackground?: boolean}>} props
 */
export default function Layout({
  children,
  gradientBackground,
  whiteBackground,
}) {
  const [isHeaderCollapsed, setCollapsedHeader] = useState(false);

  // useCallback ensures the reference to `handleWindowScroll` never changes, even after a render
  const handleWindowScroll = useCallback(
    () =>
      // Doesn't trigger a re-render if the states are shallow equal
      setCollapsedHeader(!isTopVerticalScroll()),
    // Keeps this equal throughout any layout render
    []
  );

  useReferralCookie();

  /** Check on initial render. SSR prevents from initializing the value from window */
  useEffect(() => handleWindowScroll(), [handleWindowScroll]);

  useEffect(() => {
    window.addEventListener("scroll", handleWindowScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleWindowScroll);
    };
    /** Don't clean-up/subscribe this every time the component re-renders */
  }, [handleWindowScroll]);

  return (
    <LiveChatLoaderProvider
      provider="intercom"
      providerKey="ae0v6osl"
      idlePeriod={100}
    >
      <div
        className={classNames(styles.layout, {
          [styles.gradientBackground]: gradientBackground,
          [styles.whiteBackground]: whiteBackground,
        })}
      >
        <div className={styles.container}>
          <Header isCollapsed={isHeaderCollapsed} />
          <main
            className={classNames(styles.main, {
              [styles.headerCollapsed]: isHeaderCollapsed,
            })}
          >
            {children}
          </main>
          <Footer />
        </div>
        <Intercom color="#2853E2" />
      </div>
    </LiveChatLoaderProvider>
  );
}
